import { gatewayApiClient } from '../../_shared/api/gatewayApiClient';
import type { PageResponse } from '../../_shared/types/shared';
import type { ConsumerRow, ConsumerFormValues, ConsumerFilters } from '../types/consumer';

export const consumersApi = {
  list: async (params: ConsumerFilters & { page: number; size: number; sort?: string }) => {
    const response = await gatewayApiClient.get<PageResponse<ConsumerRow>>('/admin/consumers', { params });
    return response.data;
  },

  get: async (id: string) => {
    const response = await gatewayApiClient.get<ConsumerRow>(`/admin/consumers/${id}`);
    return response.data;
  },

  create: async (body: ConsumerFormValues) => {
    const response = await gatewayApiClient.post<ConsumerRow>('/admin/consumers', body);
    return response.data;
  },

  replace: async (id: string, body: ConsumerFormValues) => {
    const response = await gatewayApiClient.put<ConsumerRow>(`/admin/consumers/${id}`, body);
    return response.data;
  },

  delete: async (id: string) => {
    await gatewayApiClient.delete(`/admin/consumers/${id}`);
  },
};
